import React, {useMemo} from 'react';
import clsx from 'clsx';
import {SelectField} from '@netx/core-components/SelectField';
import {composeClasses, styled, WithClasses} from '@netx/core-components/Theme';
import {useSavedSearches} from '@netx/core-search-saved';
import {CommonRuleEditorProps} from '../../../types';
import {
	savedSearchRuleEditorClasses,
	getSavedSearchRuleEditorUtilityClass,
	SavedSearchRuleEditorClasses,
	SAVED_SEARCH_RULE_EDITOR_CLASS_NAME,
} from './savedSearchRuleEditorClasses';

export type SavedSearchRuleEditorOwnerState = WithClasses<
	SavedSearchRuleEditorClasses,
	{}
>;

const useUtilityClasses = (ownerState: SavedSearchRuleEditorOwnerState) => {
	const {classes} = ownerState;
	const slots = {
		root: ['root'],
	};
	return composeClasses(slots, getSavedSearchRuleEditorUtilityClass, classes);
};

const SavedSearchRuleEditorRoot = styled('div', {
	name: SAVED_SEARCH_RULE_EDITOR_CLASS_NAME,
	slot: 'Root',
})(({theme}) => ({
	display: 'flex',
	flex: '1 1 auto',
}));

type OptionParams = {
	labels: {
		[k: number]: string;
	};
	ids: number[];
};

export type SavedSearchRuleEditorProps = WithClasses<
	SavedSearchRuleEditorClasses,
	CommonRuleEditorProps & {}
>;

const SavedSearchRuleEditorInner = ({
	classes: _classes,
	className,
	elementValue1,
	onValue1Change,
}: SavedSearchRuleEditorProps) => {
	const ownerState: SavedSearchRuleEditorOwnerState = {
		classes: _classes,
		className,
	};

	const classes = useUtilityClasses(ownerState);

	const {savedSearches} = useSavedSearches();

	const options = useMemo(() => {
		return savedSearches.reduce<OptionParams>(
			(accum, savedCart, index) => {
				return {
					labels: {
						...accum.labels,
						[savedCart.id]: savedCart.title,
					},
					ids: [...accum.ids, savedCart.id],
				};
			},
			{labels: {}, ids: []},
		);
	}, [savedSearches]);

	return (
		<SavedSearchRuleEditorRoot className={clsx(classes.root, className)}>
			<SelectField<number, false, true, false>
				data-testid="saved-search-rule-value-1"
				disableClearable
				label="Saved search"
				name={'rule-value-1'}
				options={options.ids}
				value={(elementValue1 as number) || undefined}
				getOptionLabel={(option) => options.labels[option]}
				onChange={(event, value) => onValue1Change(value)}
			/>
		</SavedSearchRuleEditorRoot>
	);
};

export const SavedSearchRuleEditorPrimitive = SavedSearchRuleEditorInner;

export const SavedSearchRuleEditor = SavedSearchRuleEditorPrimitive;

export default SavedSearchRuleEditor;
